import {
  LIST_KEY_CREATE_REQUEST,
  REQUEST_TYPE,
} from 'common/constants/insulation';
import { REQUEST_STATUS } from 'common/constants';
import { useAuth } from 'features/auth';

export type State = 'EDIT' | 'VIEW';
export type RequestType = keyof typeof REQUEST_TYPE;
export type Status =
  | keyof typeof REQUEST_STATUS
  | `PENDING_PAINTING_${number}`
  | `PENDING_QAQC_${number}`;

export type NodeItem = {
  header: string;
  key: string;
  component?: React.ReactNode;
  roles?: Parameters<ReturnType<typeof useAuth>[0]['checkRole']>[];
  validate?: (
    | string
    | ((data: any, helpers?: any) => string | string[] | undefined)
  )[];
  isVisibleByRole?: boolean;
};

export type RequestDataType = Record<Status[number], NodeItem[] | []>;

export type VALIDATE_MODEL = {
  [name: Status[number]]: {
    [name: string]: (
      | string
      | ((data: any, panels?: NodeItem[]) => string | undefined)
    )[];
  };
};

export const MAP_REQUEST_NAME: Record<string, string> = {
  DRAFT: 'Request Creation',
  PENDING_VALIDTION: 'Request Validation',
  PENDING_PROPOSAL: 'Proposal',
  PENDING_REMOVAL: 'Insulation Removal',
  IN_SERVICE: 'In-Service',
  PENDING_REINSTATEMENT: 'Insulation Reinstatement',
  PENDING_QAQC: 'QAQC',
  PENDING_PAINTING: 'Painting Work',
  BILLING: 'Billing',
  CLOSED: 'Closed',
};

export const LIST_MODEL = {
  [LIST_KEY_CREATE_REQUEST.REQUESTOR_DETAIL]: ['section', 'discipline'],
  [LIST_KEY_CREATE_REQUEST.WORK_DETAIL]: ['listWorkDetail'],
  [LIST_KEY_CREATE_REQUEST.SCAFFOLD_DETAIL]: [
    (data: any) => data?.isScaffoldingRequire && 'listScaffoldDetail',
  ],
  [LIST_KEY_CREATE_REQUEST.INSULATION_DETAIL]: [
    'siteVisitDate',
    'area',
    'endDate',
    'workDescription',
    'startDate',
  ],
};

// [LIST_KEY_CREATE_REQUEST.PAINTING_DETAIL]: ['siteEnvironment'],

export const REQUEST_MODEL: VALIDATE_MODEL = {
  DRAFT: LIST_MODEL,
  PENDING_VALIDTION: {
    ...LIST_MODEL,
    [LIST_KEY_CREATE_REQUEST.PAINTING_DETAIL]: [
      'coatingTestRequired',
      'workDescription',
      (data, panels) => {
        return 'systemId';
      },
      'surfacePreparation',
      // 'mlngciAssigned',
      // 'workAssigned',
      data => {
        if (data?.systemId === 69) {
          return 'otherCoatsList';
        }
        return undefined;
      },
    ],
  },
  PENDING_PROPOSAL: {
    [LIST_KEY_CREATE_REQUEST.PROPOSAL_DETAIL]: [
      'proposalBillingDetail.data',
      'proposalBillingDetail.totalQuotedCost',
    ],
  },
  PENDING_REMOVAL: {
    [LIST_KEY_CREATE_REQUEST.REMOVAL_DETAIL]: [
      'insulationRemovalDetail.completionDate',
      'insulationRemovalDetail.workLeaderId',
    ],
  },
  PENDING_REINSTATEMENT: {
    [LIST_KEY_CREATE_REQUEST.PROPOSAL_DETAIL]: [
      'proposalBillingDetail.data',
      'proposalBillingDetail.poNumber',
      'proposalBillingDetail.totalFinalCost',
    ],
    [LIST_KEY_CREATE_REQUEST.REINSTATEMENT_DETAIL]: [
      'insulationReinstatementDetail.completionDate',
      'insulationReinstatementDetail.workLeaderId',
    ],
  },
  IN_SERVICE: {
    [LIST_KEY_CREATE_REQUEST.IN_SERVICE]: ['inservice'],
  },
  PENDING_QAQC: {
    [LIST_KEY_CREATE_REQUEST.QAQC_DETAIL]: [
      'reinstatementChecklist.overallAcceptance',
      'reinstatementChecklist.inspectionDate',
    ],
  },
  BILLING: {
    [LIST_KEY_CREATE_REQUEST.PROPOSAL_DETAIL]: [
      'billing.poNumber',
      'billing.verifiedFinalCost',
    ],
  },
};
